<div matDialogTitle>Villkorsbilaga</div>
<div [style.padding-top.px]="0" [style.padding.px]="20">
  <p style="margin-top: 0">Ange lån som bundits om i förtid.</p>
  <mat-form-field>
    <mat-label>Lånenummer</mat-label>
    <input
      #number=ngModel
      [(ngModel)]="loanNumber"
      [maxlength]="11"
      [minlength]="10"
      matInput
      name="lånenummer"
      required>
  </mat-form-field>
  <button
    (click)="getLoan()"
    [disabled]="number.invalid"
    [style.margin-left.px]="20"
    matButton="elevated"
  >Hämta
  </button>

  @if (loan()) {
    <spb-loan-display [(loan)]="loan"/>
  }
</div>
@if (!loan()) {
  <mat-dialog-actions align="end">
    <button mat-dialog-close matButton="text">Avbryt</button>
  </mat-dialog-actions>
}